import * as React from 'react';
import Box from '@mui/material/Box';
import BottomNavigation from '@mui/material/BottomNavigation';
import Paper from '@mui/material/Paper';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import GalleryIcon from '@mui/icons-material/PhotoLibrary';
import LibraryIcon from '@mui/icons-material/LibraryBooks';
import MessagesIcon from '@mui/icons-material/Message';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Link, useLocation } from 'react-router-dom';
import { useCompany } from '../contexts/Company';

export default function SimpleBottomNavigation() {
  const location = useLocation();
  const [value, setValue] = React.useState(null);
  const company = useCompany();
  const [labels, setLabels] = React.useState({});

  React.useEffect(() => {
    const path = location.pathname;
    if (path === '/sessions' || path === '/') {
      setValue(0);
    } else if (path === '/gallery') {
      setValue(1);
    } else if (path.includes('library')) {
      setValue(2);
    } else if (path === '/messages') {
        setValue(3);
    }
  }, [location]);

  React.useEffect(() => {
    console.log(company);
    if (company?.id == '45') {
      setLabels({
        yourPath: "Your Path",
        gallery: "Gallery",
        library: "Library",
        messages: "Messages"
      });
    } else {
      setLabels({
        yourPath: "Tu ruta",
        gallery: "Galería",
        library: "Biblioteca",
        messages: "Mensajes"
      });
    }
  }, [company]);

  return (
    <Box style={{ width: '100%', position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000 }}>
      <Paper elevation={3}>
        <BottomNavigation
          showLabels
          value={value}
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
        >
          <BottomNavigationAction component={Link} to="/sessions" label={labels.yourPath} icon={<AccountCircleIcon />} />
          <BottomNavigationAction component={Link} to="/gallery" label={labels.gallery} icon={<GalleryIcon />} />
          <BottomNavigationAction component={Link} to="/librarymenu" label={labels.library} icon={<LibraryIcon />} />
          <BottomNavigationAction component={Link} to="/messages" label={labels.messages} icon={<MessagesIcon />} />
        </BottomNavigation>
      </Paper>
    </Box>
  );
}